import { toNumber, roundMoney } from '@/utils/CurrencyUtil';

/**
 * Cuentas del encabezado de DetalleSale: cuánto se ha pagado, cuánto falta y
 * el chip de estado. Sin dependencias de Vue, para probarlo sin montar nada.
 */

/** Un pago cancelado (`ventaPago.eliminado`) no abona. */
export const isActivePayment = (payment) => !(payment && payment.ventaPago && payment.ventaPago.eliminado);

/**
 * `payments` es la lista de VentaPagoDetalle (`payedAmount`, `ventaPago`).
 * `percent` va de 0 a 100: un sobrepago no desborda la barra.
 */
export function paymentSummary(total, payments) {
    const totalAmount = roundMoney(total);
    const paid = roundMoney((payments || [])
        .filter(isActivePayment)
        .reduce((acc, payment) => acc + toNumber(payment.payedAmount, 0), 0));
    const balance = roundMoney(totalAmount - paid);
    const percent = totalAmount > 0
        ? Math.min(100, Math.max(0, Math.round((paid / totalAmount) * 100)))
        : 0;
    return { total: totalAmount, paid, balance, percent };
}

/**
 * Chip del encabezado. Una venta cancelada lo dice primero; el estado de cobro
 * solo se calcula para ventas y cuando ya se cargaron los pagos: no se
 * muestra un saldo que todavía no se conoce.
 */
export function headerChip({ sale, isSale, summary }) {
    if (sale.ventaEstatus === 'Cancelada') return { label: 'Cancelada', tone: 'danger' };
    if (!isSale || !summary) {
        return sale.ventaEstatus ? { label: sale.ventaEstatus, color: sale.colorEstatus } : null;
    }
    if (summary.total > 0 && summary.balance <= 0) return { label: 'Pagada', tone: 'success' };
    if (summary.paid > 0) return { label: 'Pago parcial', tone: 'warning' };
    return { label: 'Sin pagos', tone: 'pending' };
}
